import { UpdateReason } from 'APP/constants/scroll';
import Entities from 'STORE';

export const moveToBottom = async () => {
  const group = Entities.GroupsStore.activeGroup;

  if (!group || !group.counter) {
    return;
  }

  group.messagesStore.setNewMessagesPlaceholderTs(group.seenTs);
  group.messagesStore.unfocusMessage();

  const lastInViewMessageTS = Math.max(
    ...Entities.viewportMessages.viewportMessages.map(
      ({ messageId }) => group.messagesStore.getMessageById(messageId).serverTime
    )
  );

  // if TS of last message in viewPort less lastSeenTS scrolled to lastSeenTs messages
  // otherwise scroll to bottom
  if (lastInViewMessageTS < group.seenTs && group.seenTs < group.lastMessageTs) {
    Entities.ChatStore.setScrollChanged(UpdateReason.ScrollToNewMessage);
    return;
  }

  Entities.ChatStore.setScrollChanged(UpdateReason.ScrollToBottom, { isAnimated: true });
};
